var _rect, _rect2, _rect3, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 38,
    viewBox: "0 0 48 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 46,
    height: 35.5,
    rx: 5,
    fill: "white",
    stroke: "#413D45",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.75,
    y: 3.75,
    width: 40.5,
    height: 24.75,
    rx: 3,
    fill: "#C7DFF2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.25,
    y: 30.75,
    width: 13.5,
    height: 2.25,
    rx: 1.125,
    fill: "#413D45"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 21.75C26.8995 21.75 29.25 19.3995 29.25 16.5C29.25 13.6005 26.8995 11.25 24 11.25C21.1005 11.25 18.75 13.6005 18.75 16.5C18.75 19.3995 21.1005 21.75 24 21.75Z",
    fill: "#6DA6D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5485 18.5139C23.4334 18.5139 23.3215 18.4691 23.2384 18.3861L21.3938 16.581C21.218 16.4085 21.2148 16.1305 21.3874 15.9548C21.56 15.7791 21.8381 15.7759 22.014 15.9484L23.5261 17.4276L26.1411 14.5107C26.3042 14.3286 26.5855 14.3126 26.7677 14.4756C26.9499 14.6385 26.9659 14.9197 26.8029 15.1018L23.8809 18.3669C23.801 18.4564 23.6859 18.5107 23.5645 18.5139C23.5581 18.5139 23.5517 18.5139 23.5485 18.5139Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDesktop);
export default __webpack_public_path__ + "static/media/icon-desktop.5ab07948412049a07e2c90e032baef36.svg";
export { ForwardRef as ReactComponent };